module.exports = "https://web-assets.ifttt.com/packs/media/layout/plus-535ad8fa.svg";